import React from 'react';
import './SystemGrid.css';
import { systems } from '../data/systems';

// Imagens de fundo para cada sistema
const backgroundImages = {
  protocolo: 'https://images.unsplash.com/photo-1619418602850-35ad20aa1700?w=800&auto=format&fit=crop',
  processoAdministrativo: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&auto=format&fit=crop',
  patrimonio: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&auto=format&fit=crop',
  secretarias: 'https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=800&auto=format&fit=crop',
  legislacao: 'https://plus.unsplash.com/premium_photo-1694088516834-6fa55faab454?w=800&auto=format&fit=crop',
  servidores: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&auto=format&fit=crop',
  servidoresInterno: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&auto=format&fit=crop'
};

// Função para obter a imagem de fundo com base na URL do sistema
const getBackgroundImage = (url) => {
  if (url.includes('semgi/login')) return backgroundImages.protocolo;
  if (url.includes('processo-administrativo')) return backgroundImages.processoAdministrativo;
  if (url.includes('patrimonio')) return backgroundImages.patrimonio;
  if (url.includes('secretarias')) return backgroundImages.secretarias;
  if (url.includes('legislacao')) return backgroundImages.legislacao;
  if (url.includes('http://gestaodacidade.com.br:3004/login')) return backgroundImages.servidores;
  if (url.includes('http://192.168.128.251:3004/')) return backgroundImages.servidoresInterno;
  return '';
};

const SystemGrid = () => {
  return (
    <div className="system-grid">
      {systems.map(system => (
        <a 
          key={system.id} 
          href={system.url} 
          className="system-card" 
          style={{ 
            backgroundImage: `url(${getBackgroundImage(system.url)})`
          }}
        >
          <h2 className="system-title">{system.title}</h2>
          <p className="system-description">{system.description}</p>
        </a>
      ))}
    </div>
  );
};

export default SystemGrid;